import { Component, Input } from "@angular/core";

@Component({
  selector: "app-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.css"],
})
export class AvatarComponent {
  @Input()
  backgroundColor: string = "#3498db";
  @Input()
  color: string = "#fff";
  @Input()
  size: "sm" | "md" = "md";
}
